/**
 * Custom-rug order minimum — checkout blocking for the cart page and drawer.
 *
 * snippets/custom-rug-cart-minimum.liquid renders the notice server-side and
 * marks it with [data-custom-rug-block]. This disables every route to checkout
 * inside the same cart container while that flag is present — including the
 * express buttons (Shop Pay / PayPal / G Pay), which post straight to checkout
 * and would otherwise walk right past the notice.
 *
 * Re-runs on the theme's own cart events and on any DOM replacement of a cart
 * container, so a quantity change or a removal re-evaluates immediately.
 *
 * Note: this is a storefront guard. It stops shoppers, not hand-crafted
 * requests; genuine enforcement would need a checkout validation function.
 */
(function () {
  var CART_SCOPES = [
    '#cart', '#cart-summary', '.cart__summary',
    // theme drawer
    '#cart-drawer', '.cart-drawer',
    // the drawer this store actually uses (sections/lesure-cart.liquid)
    '#CartDrawer', '#CartDrawerContent', '#CartFooter'
  ];

  function scopes() {
    var out = [];
    CART_SCOPES.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (out.indexOf(el) === -1) out.push(el);
      });
    });
    return out;
  }

  /** Blocked when a notice is present anywhere in the document. */
  function isBlocked() {
    return !!document.querySelector('[data-custom-rug-block]');
  }

  function checkoutTargets(root) {
    var els = [];
    root.querySelectorAll('[name="checkout"], #CheckoutBtn, .checkout-btn').forEach(function (b) { els.push(b); });
    // Express / accelerated checkout buttons bypass the cart form entirely.
    root.querySelectorAll(
      '.additional-checkout-buttons, .dynamic-checkout__content, [data-shopify="dynamic-checkout-cart"], [data-shopify="payment-button"]'
    ).forEach(function (b) { els.push(b); });
    return els;
  }

  function apply() {
    var blocked = isBlocked();

    scopes().forEach(function (root) {
      checkoutTargets(root).forEach(function (el) {
        if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
          el.disabled = blocked;
          el.classList.toggle('is-disabled', blocked);
          el.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        } else {
          // Container of express buttons: hide it outright so nothing inside
          // can be clicked or focused.
          el.classList.toggle('cr-min-hidden', blocked);
          el.setAttribute('aria-hidden', blocked ? 'true' : 'false');
        }
      });
    });
  }

  // Last-ditch: swallow a checkout submit if anything slipped through.
  document.addEventListener(
    'click',
    function (evt) {
      if (!isBlocked()) return;
      var t = evt.target.closest('[name="checkout"], #CheckoutBtn, .checkout-btn, [data-shopify="payment-button"]');
      if (!t) return;
      evt.preventDefault();
      evt.stopPropagation();
      var notice = document.querySelector('[data-custom-rug-block]');
      if (notice) notice.scrollIntoView({ block: 'center', behavior: 'smooth' });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', apply);
  // The theme re-renders cart sections on line-item changes.
  document.addEventListener('on:line-item:change', apply);
  document.addEventListener('on:cart:change', apply);
  document.addEventListener('on:cart:error', apply);

  // Section Rendering swaps cart markup without firing a load event, so watch
  // for the notice appearing or disappearing.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { apply(); });
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }

  apply();
})();
